var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"operation"},[_c('div',{staticClass:"search-box"},[_vm._t("search-box")],2),_c('div',{staticClass:"btn-box"},[_vm._t("btn-box")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }